import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
    boxShadow: "inset 1px 2px 2px rgba(0, 0, 0, 0.4)",
    "& label.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "&:hover label": {
      color: theme.palette.secondary.main,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 0,
      "&:hover fieldset": {
        borderColor: theme.palette.secondary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  label: {
    marginBottom: theme.spacing(1),
    color: "#000",
  },
  error: {
    color: "red",
  },
}));

export default useStyles;
